export const autoHomeRootRoute = 'autos';
export const calendarRoute = 'calendar';
